<template>
    <zen-message-modal :isOpen="isOpen" title="Rotate token?">
        <p class="text-sm text-taupe-500 mb-4">
            A new token will be created with the same scopes and permissions as
            <strong>{{ target?.name }}</strong
            >. The old token will remain valid during a grace period.
        </p>
        <div class="mb-4 mt-4">
            <label
                for="grace-period"
                class="block text-sm font-medium text-taupe-800 mb-1"
                >Grace period (hours)</label
            >
            <input
                type="number"
                id="grace-period"
                v-model.number="hours"
                min="1"
                max="168"
                class="block w-full rounded-md border-taupe-300 bg-white px-3 py-2 text-taupe-900 shadow-xs focus:border-sky-500 focus:ring-sky-500 sm:text-sm"
            />
            <p class="mt-1 text-xs text-taupe-500">
                The old token will be automatically revoked after this period.
                Max 168 hours (7 days).
            </p>
        </div>
        <template v-slot:buttons>
            <zen-button variant="secondary" @click="$emit('close')">
                Cancel
            </zen-button>
            <zen-button
                variant="primary"
                :processing="processing"
                processing-label="Rotating…"
                @click="$emit('confirm')"
            >
                Rotate token
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'RotateApiTokenModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        target: {
            type: Object,
            default: null,
        },
        modelValue: {
            type: Number,
            required: true,
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm', 'update:modelValue'],
    computed: {
        hours: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            },
        },
    },
}
</script>
